(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-collection-picker-grid"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('collection-picker-count-label')) {
    customElements.define('collection-picker-count-label', class extends HTMLElement {
      connectedCallback() {
        const count = this.parentElement.querySelector('[data-collection-count]');
        const updateLabel = () => {
          this.textContent = Number(count.textContent) === 1 ? 'collection' : this.dataset.pluralLabel;
        };
        this.observer = new MutationObserver(updateLabel);
        this.observer.observe(count, { childList: true, characterData: true, subtree: true });
        updateLabel();
      }

      disconnectedCallback() {
        this.observer.disconnect();
      }
    });
  }

  if (Shopify.designMode) {
    // Delegation also handles section replacements and block reordering in the editor.
    document.addEventListener('shopify:block:select', async (event) => {
      const grid = event.target.closest('[data-collection-picker-grid]');
      if (!grid) return;
      await customElements.whenDefined('custom-collection-grid');
      if (!grid.isConnected) return;
      const card = grid.cards.find((item) => item.dataset.blockId === event.detail.blockId);
      if (!card) return;
      // Restore block order and remove filters so the selected card can always be found.
      grid.searchInput.value = '';
      grid.sortSelect.value = 'featured';
      const position = grid.cards.indexOf(card);
      grid.visibleLimit = Math.max(6, Math.ceil((position + 1) / 6) * 6);
      grid.update();
      card.scrollIntoView({ block: 'nearest', behavior: 'auto' });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-collection-products"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
